<div
  role="dialog"
  aria-expanded="false"
  class="_overlay absolute inset-0 h-full w-full z-10 cursor-pointer"
  (click)="close()"
></div>
<div
  role="dialog"
  class="_content bg-white-500 p-4 md:p-8 relative z-20 rounded-t-md w-full md:rounded-b-md md:w-auto shadow-lg overflow-auto"
>
  <ng-container [ngSwitch]="contentType">
    <ng-container *ngSwitchCase="'string'">
      <div class="box">
        <div [innerHTML]="contentAsString"></div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'template'">
      <ng-container
        *ngTemplateOutlet="contentAsTemplate; context: context"
      ></ng-container>
    </ng-container>

    <ng-container *ngSwitchCase="'component'">
      <ng-container *ngComponentOutlet="contentAsType"></ng-container>
    </ng-container>
  </ng-container>
</div>
